export const colors = {
  primary: "#d4f2b2",
  good: "#00FF00",
  evil: "#FF0000 ",
};

export const characterToProfileImage = {
  "Luke Skywalker":
    "https://static1.moviewebimages.com/wordpress/wp-content/uploads/article/6He1Adg1iwCnzIu2Kpur3tGe9LL7N5.jpg?q=50&fit=contain&w=1500&h=&dpr=1.5",
  "C-3PO":
    "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/2df9363a-3023-48fa-8cba-35e28ae2dd85/d9kb64r-99e77607-fc03-4ec1-821b-6a1adf005688.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzJkZjkzNjNhLTMwMjMtNDhmYS04Y2JhLTM1ZTI4YWUyZGQ4NVwvZDlrYjY0ci05OWU3NzYwNy1mYzAzLTRlYzEtODIxYi02YTFhZGYwMDU2ODguanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.ak5g03Q5L7dgQck6jQqdOJ6tofZaKm6KM7N0Km-Huug",
  "R2-D2":
    "https://i.pinimg.com/550x/2c/af/2a/2caf2a228ab729889bfc2fcc999e8817.jpg",
  "Darth Vader":
    "https://static.wikia.nocookie.net/741b68a6-65c7-48f6-a8d6-4eff212d4d2a/scale-to-width/755",
  "Leia Organa":
    "https://starwarsblog.starwars.com/wp-content/uploads/2021/03/which-leia-are-you-TALL.jpg",
  "Owen Lars":
    "https://i.pinimg.com/564x/e4/e0/58/e4e058824f8c68e37245ca2a465af88d.jpg",
  "Beru Whitesun lars":
    "https://overlydevotedarchivist.net/wp-content/uploads/2015/09/tumblr_n4gsts4rba1rhqhm5o1_500.png.jpg",
  "R5-D4": "https://pbs.twimg.com/media/Elw4eYSVkAAeYNd.jpg",
  "Biggs Darklighter":
    "https://starwarsblog.starwars.com/wp-content/uploads/2015/08/Biggs-1536x864-231144930049.png",
  "Obi-Wan Kenobi":
    "https://starwarsblog.starwars.com/wp-content/uploads/2022/04/Obi-wan-kenobi-quote-quiz-TALL.jpg",
};
